function getFileSize (size) {
  const unt = ['Bytes', 'KB', 'MB', 'GB']
  let i = 0
  while (size > 900) {
    size /= 1024
    i++
  }
  return (Math.round(size * 100) / 100) + ' ' + unt[i]
}

const setFilesChange = () => {
  const formFiles = document.querySelectorAll('.form-file__box')

  formFiles.forEach((formFile) => {
    const fileInput = formFile.querySelector('.form-file__input')
    const removeBtn = formFile.querySelector('.form-file__remove')
    const fileName = formFile.querySelector('.form-file__name')

    fileInput.addEventListener('change', function () {
      if (this.files.length > 0) {
        const file = this.files[0]
        const fileURL = URL.createObjectURL(file)
        fileName.innerHTML = `
        <span class="icon"></span>
        <a href="${fileURL}" target="_blank">${file.name}</a>
        <span>${getFileSize(file.size)}</span>`
        formFile.classList.add('uploaded')
      }
    })

    removeBtn.addEventListener('click', function (event) {
      event.preventDefault()
      fileInput.value = ''
      fileName.innerHTML = ''
      formFile.classList.remove('uploaded')
    })
  })
}

export default setFilesChange
